/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfigurazioneSmsForm } from './configurazione-sms-form';


export interface ConfigurazioneSmsTestRequest { 
    configurazione?: ConfigurazioneSmsForm;
    target_telefono: string;
}

